import React, { useState } from 'react';
import { Clock } from 'lucide-react';
import { useStore } from '../store';

export const Logo: React.FC = () => {
  const [imageError, setImageError] = useState(false);
  const { setQuery, setAiResponse } = useStore();

  const handleLogoClick = () => {
    setQuery('');
    setAiResponse(null);
  };

  if (imageError) {
    return (
      <div className="flex justify-center mb-8">
        <button
          onClick={handleLogoClick}
          className="flex items-center gap-3 bg-gradient-to-r from-orange-400 to-orange-500 px-6 py-3 rounded-full shadow-md hover:shadow-lg transition-all duration-300"
        >
          <Clock className="w-8 h-8 text-white" />
          <span className="text-2xl font-bold text-white">מתי כדאי?</span>
        </button>
      </div>
    );
  }

  return (
    <div className="flex justify-center mb-8">
      <button
        onClick={handleLogoClick}
        className="bg-gradient-to-r from-orange-400 to-orange-500 p-4 rounded-2xl shadow-md hover:shadow-lg transition-all duration-300"
      >
        <img 
          src="/logo.png"
          alt="מתי כדאי?" 
          className="h-20 w-auto hover:scale-105 transition-transform duration-300"
          onError={() => setImageError(true)}
        />
      </button>
    </div>
  );
};